import { GameModal } from "./GameModal";

interface Props {
  open: boolean;
  solo?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export function QuitGameModal({ open, solo, onConfirm, onClose }: Props) {
  return (
    <GameModal open={open} onClose={onClose} labelledBy="quit-game-title">
      <h2 id="quit-game-title" className="cw-title text-2xl font-bold">
        Quitter la partie ?
      </h2>
      <p className="text-sm text-violet-300/80 text-left">
        {solo
          ? "La partie sera terminée."
          : "Votre frise restera visible pour les autres joueurs, mais vous ne participerez plus aux manches suivantes."}
      </p>
      <div className="flex gap-3 pt-2">
        <button type="button" className="cw-btn cw-btn-secondary flex-1" onClick={onClose}>
          Annuler
        </button>
        <button type="button" className="cw-btn cw-btn-primary flex-1" onClick={onConfirm}>
          Quitter
        </button>
      </div>
    </GameModal>
  );
}
